(ns frontend.test.color.view
  (:require
    [common.localization :as loc]
    [ui.color :as c]
    [ui.components.text.view :as text]
    [ui.util :as uu]))

(defn view
  []
  [:div
   {:class (uu/cm "flex flex-col gap-3 bg-base-light text-base-light-text")}

   (let [{:keys [palette]} (::c/theme-normal c/themes)]
     (->> palette
          (sort-by first)
          (map
            (fn [[ck _shades]]
              ^{:key (str "theme-color-" ck)}
              [:div
               {:style {:border  (str "1px solid " (c/color ck))
                        :padding "12px"
                        :margin  "12px"}}
               [text/h2 (loc/tr ck)]
               (->> [["Full" c/color c/text c/border]
                     ["Scale 1" c/scale-1 c/text-scale-1 c/border-scale-1]
                     ["Scale 2" c/scale-2 c/text-scale-2 c/border-scale-2]]
                    (map (fn [[label bg-color-fn fg-color-fn border-color-fn]]
                           [:<>
                            [text/label {} label]
                            [:div
                             {:style {:background-color (bg-color-fn ck)
                                      :color            (fg-color-fn ck)
                                      :padding          "8px 12px"
                                      :border-width     "1px"
                                      :border-style     "solid"
                                      :border-color     (border-color-fn ck)
                                      :margin           "8px"}}
                             (str "BG : " (bg-color-fn ck) " - FG : " (fg-color-fn ck))]]))
                    (doall))]))
          (doall)))])
